import type { UUID } from "utils";

const BASE_URL = "/configuration/customers/:id/checkout-branding";

export const PAGE_URLS = {
  details: BASE_URL,
  edit: `${BASE_URL}/edit`,
  getDetails: (customerId: UUID) =>
    `/configuration/customers/${customerId}/checkout-branding`,
};
